import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MsalEnvironmentConfig } from '../models';

export const msalGuardConfigFactory = (config: MsalEnvironmentConfig): MsalGuardConfiguration => {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: [...config.apiConfig[1].scopes] }
  };
};

export const msalInterceptorConfigFactory = (config: MsalEnvironmentConfig): MsalInterceptorConfiguration => {
  const protectedResourceMap = new Map<string, string[]>();
  for (const item of config.apiConfig) {
    protectedResourceMap.set(item.uri, item.scopes);
  }
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
};

export const provideMsalConfiguration = (config: MsalEnvironmentConfig): EnvironmentProviders =>
  makeEnvironmentProviders([
    {
      provide: MSAL_INSTANCE,
      useFactory: (): IPublicClientApplication => new PublicClientApplication(config.msalConfig)
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: () => msalGuardConfigFactory(config)
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: () => msalInterceptorConfigFactory(config)
    }
  ]);
